import { Input, Modal, Space } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

import Form from '../Form';
import { JobPostingActionModal } from './RequestJobPostingActionsModal';

const CancelRequestJobPostingModal: React.FC<JobPostingActionModal> = ({
  requestJobPosting,
  form,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Modal {...props}>
      <Space direction="vertical">
        <span>
          <Trans>
            Ao cancelar a requisição, o fluxo será suspenso e não será possível reiniciá-lo. Tem
            certeza que deseja cancelar a requisição
          </Trans>{' '}
          <strong>{requestJobPosting.name}</strong>?
        </span>
        <Form form={form}>
          <Form.Item name="comment">
            <Input.TextArea
              placeholder={t('Digite o motivo do cancelamento da requisição de vaga')}
              defaultValue=""
            />
          </Form.Item>
        </Form>
      </Space>
    </Modal>
  );
};

export default CancelRequestJobPostingModal;
